import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { ArticleResponse } from '@appTypes/articleType';
import { Actions, actions } from '@redux/modules/localArticles';
import { TypedEpic } from './types';

const fetchLocalArticlesEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_LOCAL_ARTICLES),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getLocalArticles.request>[]
    >,
    switchMap(([action]: { payload: string }[]) =>
      fromApiRequest((signal) =>
        apiClient.get<ArticleResponse>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].articles.get(action.payload),
        }),
      ).pipe(
        map((response) => actions.getLocalArticles.success(response.data)),
        catchError((err) => of(actions.getLocalArticles.failure(toReduxError(err, 'Could not get list of articles')))),
      ),
    ),
  );

const fetchMoreLocalArticlesEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_MORE_LOCAL_ARTICLES),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof actions.getMoreLocalArticles.request>[]
    >,
    switchMap(([action]: { payload: string }[]) => {
      // Parse the query string from the payload and add includeCategories=false
      const searchParams = new URLSearchParams(action.payload);
      searchParams.set('includeCategories', 'false');

      const params = Object.fromEntries(searchParams.entries());

      return fromApiRequest((signal) =>
        apiClient.get<ArticleResponse>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].articles.list,
          params,
        }),
      ).pipe(
        map((response) => actions.getMoreLocalArticles.success(response.data)),
        catchError((err) => of(actions.getMoreLocalArticles.failure(toReduxError(err, 'Could not get more articles')))),
      );
    }),
  );

export const epics: TypedEpic[] = [fetchLocalArticlesEpic, fetchMoreLocalArticlesEpic];
